import { format } from '@finance/datetime'

// 时间格式化
export const formatDate = (dateStr: number | string, formatStr?: string) => {
  return format(+new Date(dateStr), formatStr)
}

export const formatTimestamp = (dateStr: number | string, formatStr?: string) => {
  const timestamp = Number(dateStr)
  return format(+new Date(timestamp), formatStr)
}

// export const formatMoneyNumber = (number: number | string, fixed = 0) => {
//   try {
//     let res = `${number}`
//     let _fixed = fixed

//     const point = res.indexOf('.')
//     if (point === -1) {
//       res = `${res}.00`
//     }
//     if (res.length - point < 3) {
//       res = `${res}0`
//     }
//     res = res.substring(0, res.indexOf('.') + 3)
//     res = res.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//     // 保留几位
//     _fixed = fixed <= 0 ? -1 : fixed
//     const l = res.length
//     const d = l - (2 - _fixed)

//     return res.substr(0, d)
//   } catch (error) {
//     console.log('[getFormatMoneyNumber 错误]', error)
//     return number
//   }
// }

// export const formatMoneyCentToYuan = (num: number) => {
//   return formatMoneyNumber(num / 100, 2)
// }

// export const MoneyCentToYuan = (num: number) => {
//   return formatMoneyNumber(num / 100)
// }

export const formatMoneyPoint = (num: number) => {
  if (!num) {
    return ''
  }
  const arr = String(num).split('.')
  if (arr.length === 1) {
    return arr[0]
  } else {
    return Number(arr[1]) > 0 ? `${arr[0]}.${arr[1]}` : arr[0]
  }
}
